module.exports = __webpack_public_path__ + "static/media/DigitalLockIcon.67ff7db0.svg";